import { SearchPicker } from '@/components/search/SearchPicker.web';
import type { LinkablePage } from '@/lib/blocks/page-link-search';

type BlockMentionPickerProps = {
  query: string;
  selectedIndex: number;
  onSelect: (page: LinkablePage) => void;
};

export function BlockMentionPicker({ query, selectedIndex, onSelect }: BlockMentionPickerProps) {
  return (
    <SearchPicker
      query={query}
      selectedIndex={selectedIndex}
      onSelect={(item) =>
        onSelect({
          id: item.containerId,
          title: item.title,
          type: item.containerType,
        })
      }
    />
  );
}
